import { Tag } from '@nimbus-ds/components';
import { differenceInDays } from 'date-fns';
import { PayOrderStatus } from '@tiendanube/common';
import { useGetPlanDebt } from 'domains/Auth/hooks';
import { PaymentStatusTag } from 'domains/Billing/Checkout/pages/PlansAndSubscriptions/components';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';

interface TrialStatusTagProps {
  paymentStatus: PayOrderStatus;
}

export default function TrialStatusTag({
  paymentStatus,
}: Readonly<TrialStatusTagProps>) {
  const t = useTranslationBilling(
    'checkout.plansAndSubscriptions.paymentsTabs.toPay',
  );
  const { isSuccess, planDebtData } = useGetPlanDebt(true, true);

  if (!isSuccess) {
    return null;
  }

  const daysUntilNextPayment =
    planDebtData?.nextPaymentDate &&
    differenceInDays(new Date(planDebtData?.nextPaymentDate), new Date());

  if (!daysUntilNextPayment || daysUntilNextPayment <= 0) {
    return <PaymentStatusTag paymentStatus={paymentStatus} />;
  }

  return (
    <Tag appearance="neutral">
      {t('trialStatusTag', { expiresIn: daysUntilNextPayment })}
    </Tag>
  );
}
